import { SectionList } from "native-base";

export default SectionList;